export const siteAssetsBundlesConfig = {
    parts: false,
    components: false,
    host: true,
};
export const siteAssetsConventions = {
    getComponentName: ({ componentName }) => {
        return componentName;
    },
    patterns: [
        {
            part: 'mapper',
            path: '{,*/}%ComponentName%/viewer/%ComponentName%.mapper.ts',
        },
    ],
};
//# sourceMappingURL=siteAssets.js.map